import { $taskCategories } from './states';
import { fetchTaskCategories } from './effects';

// Fetch task categories
$taskCategories.on(fetchTaskCategories.doneData, (_, data) => data);
